import angular from 'angular';
import accountSettingsModule from '../accountSettingsModule';

function accountSettingsModalEmailVerifyController($scope, accountsService, modalData) {
  'ngInject';

  angular.extend($scope, modalData);
  $scope.verificationEmailSent = false;
  $scope.verificationEmailError = false;

  $scope.beginAccountVerifyEmailAddress = function() {
    accountsService.beginAccountVerifyEmailAddress().then(
      function() {
        $scope.verificationEmailSent = true;
      },
      function(error) {
        $scope.verificationEmailError = true;
        $scope.error = accountsService.getEmailErrorMessageFromCode(error);
      }
    );
  };

  $scope.sendVerificationEmail = function() {
    $scope.verifiedEmailRequired = false;
    $scope.beginAccountVerifyEmailAddress();
  };

  function init() {
    if (!$scope.verifiedEmailRequired) {
      $scope.beginAccountVerifyEmailAddress();
    }
  }

  init();
}

accountSettingsModule.controller(
  'accountSettingsModalEmailVerifyController',
  accountSettingsModalEmailVerifyController
);

export default accountSettingsModalEmailVerifyController;
